<template>
    <b-container fluid class="animated fadeIn">
        <h1>Exibir Procurador</h1>
        <b-card>
            <b-row>
                <b-col xs="12" sm="12" md="8" lg="8" xl="8">
                    <b-form-group label="Nome:" label-for="nome" class="text-label">
                        <b-form-input 
                            name="nome"
                            v-model="procurador.nome" 
                            type="text" 
                            maxlength="90"
                            :disabled="true" />
                    </b-form-group>
                </b-col>
            </b-row>
            <b-row>
                <b-col xs="12" sm="12" md="4" lg="4" xl="4">
                    <b-form-group label="Número CPF:" label-for="cpf" class="text-label">
                        <b-form-input 
                            name="cpf"
                            v-model="procurador.cpf" 
                            type="text" 
                            maxlength="14"
                            v-mask="['###.###.###-##']"
                            :disabled="true"/>
                    </b-form-group>
                </b-col>
                <b-col xs="12" sm="12" md="4" lg="4" xl="4">
                    <b-form-group label="Código Procurador SPJ:" label-for="codProcuradorSPJ" class="text-label">
                        <b-form-input 
                            name="codProcuradorSPJ"
                            v-model="procurador.codProcuradorSPJ" 
                            type="text"
                            maxlength="12"
                            style="text-transform: uppercase"
                            :disabled="true" />
                    </b-form-group>
                </b-col>
            </b-row>
            <b-row>
                <b-col xs="12" sm="12" md="4" lg="4" xl="4">
                    <b-form-group label="Número OAB:" label-for="numeroOab" class="text-label">
                        <b-form-input 
                            name="numeroOab"
                            v-model="procurador.numeroOab" 
                            type="number" 
                            maxlength="6"
                            :disabled="true" />
                    </b-form-group>
                </b-col>
                <b-col xs="12" sm="12" md="4" lg="4" xl="4">
                    <b-form-group label="UF OAB:" label-for="ufOAB" class="text-label">
                        <b-form-select
                            name="ufOAB"
                            v-model="procurador.ufOAB"
                            :value="procurador.ufOAB"
                            :disabled="true">
                            <template v-slot:first>
                                <option :value="null" disabled>-- Selecione --</option>
                            </template>
                            <option 
                                v-for="uf in dados.ufs" 
                                :key="uf.sigla"
                                :value="uf">
                                {{ uf.sigla }}
                            </option>
                        </b-form-select>
                    </b-form-group>
                </b-col>
            </b-row>
            <b-row>
                <b-col xs="12" sm="12" md="4" lg="4" xl="4">
                    <b-form-group label="Usuário:" label-for="usuario" class="text-label">
                        <b-form-select
                            name="usuario"
                            v-model="procurador.usuario"
                            :value="procurador.usuario"
                            :disabled="true">
                            <template v-slot:first>
                                <option :value="null" disabled>-- Selecione --</option>
                            </template>
                            <option 
                                v-for="usuario in dados.usuarios" 
                                :key="usuario.codUsuario"
                                :value="usuario">
                                {{ usuario.nomeUsuario }}
                            </option>
                        </b-form-select>
                    </b-form-group>
                </b-col>
                <b-col xs="12" sm="12" md="4" lg="4" xl="4">
                    <b-form-group label="Grupo de Trabalho:" label-for="grupoTrabalho" class="text-label">
                        <b-form-select
                            name="grupoTrabalho"
                            v-model="procurador.grupoTrabalho"
                            :value="procurador.grupoTrabalho"
                            :disabled="true">
                            <template v-slot:first>
                                <option :value="null" disabled></option>
                            </template>
                            <option 
                                v-for="gt in dados.grupoTrabalho" 
                                :key="gt.id"
                                :value="gt">
                                {{ gt.nome }}
                            </option>
                        </b-form-select>
                    </b-form-group>
                </b-col>
            </b-row>
            <b-row>
                <b-col xs="12" sm="12" md="2" lg="2" xl="2">
                    <b-form-group label="CEP:" label-for="cep" class="text-label">
                        <b-form inline>
                            <b-form-input 
                                name="cep"
                                v-model="procurador.cep" 
                                type="text" 
                                maxlength="9"
                                v-mask="['#####-###']"
                                :disabled="true"/>
                        </b-form>
                    </b-form-group>
                </b-col>
                <b-col xs="12" sm="12" md="4" lg="4" xl="4">
                    <b-form-group label="Última Sincronização de Agenda:" label-for="ultimaSyncAgenda" class="text-label">
                        <b-form-input 
                            name="ultimaSyncAgenda"
                            v-model="procurador.dataHoraUltimaSincronizacaoFormatada" 
                            type="text" 
                            :disabled="true" />
                    </b-form-group>
                </b-col>
            </b-row>
            <b-row>
                <b-col xs="12" sm="12" md="6" lg="6" xl="6">
                    <b-form-group label="Logradouro:" label-for="logradouro" class="text-label">
                        <b-form-input 
                            name="logradouro"
                            v-model="procurador.logradouro" 
                            type="text" 
                            maxlength="100"
                            :disabled="true" />
                    </b-form-group>
                </b-col>
                <b-col xs="12" sm="12" md="2" lg="2" xl="2">
                    <b-form-group label="Número:" label-for="numeroLogradouro" class="text-label">
                        <b-form-input 
                            name="numeroLogradouro"
                            v-model="procurador.numeroLogradouro" 
                            type="text" 
                            maxlength="10"
                            :disabled="true" />
                    </b-form-group>
                </b-col>
            </b-row>
            <b-row>
                <b-col xs="12" sm="12" md="4" lg="4" xl="4">
                    <b-form-group label="Complemento:" label-for="complemento" class="text-label">
                        <b-form-input 
                            name="complemento"
                            v-model="procurador.complemento" 
                            type="text" 
                            maxlength="30"
                            :disabled="true" />
                    </b-form-group>
                </b-col>
                <b-col xs="12" sm="12" md="4" lg="4" xl="4">
                    <b-form-group label="Bairro:" label-for="bairro" class="text-label">
                        <b-form-input 
                            name="bairro"
                            v-model="procurador.bairro" 
                            type="text" 
                            maxlength="50"
                            :disabled="true" />
                    </b-form-group>
                </b-col>
            </b-row>
            <b-row>
                <b-col xs="12" sm="12" md="4" lg="4" xl="4">
                    <b-form-group label="E-mail:" label-for="email" class="text-label">
                        <b-form-input 
                            name="email"
                            v-model="procurador.email" 
                            type="text" 
                            maxlength="60"
                            :disabled="true" />
                    </b-form-group>
                </b-col>
                <b-col xs="12" sm="12" md="4" lg="4" xl="4">
                    <b-form-group label="Telefone Fixo:" label-for="telefoneFixo" class="text-label">
                        <b-form-input 
                            name="telefoneFixo"
                            v-model="procurador.telefoneFixo" 
                            v-mask="['(##) ####-####']"
                            type="text"
                            :disabled="true" />
                    </b-form-group>
                </b-col>
            </b-row>
            <b-row>
                <b-col xs="12" sm="12" md="4" lg="4" xl="4">
                    <b-form-group label="Telefone Celular:" label-for="telefoneCelular" class="text-label">
                        <b-form-input 
                            name="telefoneCelular"
                            v-model="procurador.telefoneCelular" 
                            v-mask="['(##) #####-####']"
                            type="text"
                            :disabled="true" />
                    </b-form-group>
                </b-col>
                <b-col xs="12" sm="12" md="4" lg="4" xl="4">
                    <b-form-group label="Assessor:" label-for="assessores" class="text-label">
                        <multiselect
                            name="assessores"
                            v-model="procurador.assessores"
                            :show-labels="false"
                            :options="dados.assessores"
                            :multiple="true"
                            placeholder="Selecione"
                            track-by="codUsuario"
                            label="nomeUsuario"
                            :disabled="true"
                        >
                        </multiselect>
                    </b-form-group>
                </b-col>
            </b-row>
            <b-row>
                <b-col xs="12" sm="12" md="4" lg="4" xl="4">
                    <b-form-group
                        label="Situação:"
                        label-for="ativo">
                        <b-form-checkbox :disabled="true" switch v-model="procurador.indAtivo">{{ procurador.indAtivo ? 'Ativo' : 'Inativo'}}</b-form-checkbox>
                    </b-form-group>
                </b-col>
            </b-row>
            <b-row>
                <b-col xs="12" sm="12" md="4" lg="4" xl="4">
                    <b-button variant="primary" class="ml-2" @click="voltar">
                        <i class="fa fa-reply"></i> Voltar
                    </b-button>
                </b-col>
            </b-row>
        </b-card>
    </b-container>
</template>

<script>
import axios from 'axios'
import formatarMixins from '../../../mixins/formatarMixins'

export default {
    name: 'ManterProcuradorExibir',
    mixins: [ formatarMixins ],
    data() {
        return {
            procurador: {
                nome: null,
                cpf: null,
                codProcuradorSPJ: null,
                numeroOab: null,
                ufOAB: null,
                usuario: null,
                cep: null,
                logradouro: null,
                numeroLogradouro: null,
                complemento: null,
                bairro: null,
                email: null,
                telefoneFixo: null,
                telefoneCelular: null,
                indAtivo: true,
                grupoTrabalho: null,
                assessores: null
            },
            dados: {
                usuarios: [],
                ufs: [],
                grupoTrabalho: [],
                assessores: []
            },
        }
    },
    methods: {

        voltar() {
            this.$store.commit("setProcurador", null);
            this.$router.push({ path: '/procurador' })
        },

        /**
         * Exibe erros dos catch
         */
        exibirErro(error) {
            this.$store.commit("setMessages", { message: 'Erro!', errors: [error] });
        },

        /**
         * Listar UFs
         */
        async listarUfs() {
            const urlApi = process.env.VUE_APP_ROOT_API
            const token = JSON.parse(this.$store.getters.getUser).access_token

            axios.get(`${urlApi}/v1/procurador/listarUfs`, {
                headers: {
                    'Authorization': token,
                    'Content-Type': 'application/json',
                }
            })
            .then(response => {
              this.dados.ufs = response.data
            })
        },

        /**
         * Listar Usuarios
         */
        async listarUsuarios() {
            const urlApi = process.env.VUE_APP_ROOT_API
            const token = JSON.parse(this.$store.getters.getUser).access_token

            axios.get(`${urlApi}/v1/procurador/listarUsuarios`, {
                headers: {
                    'Authorization': token,
                    'Content-Type': 'application/json',
                }
            })
            .then(response => {
              this.dados.usuarios = response.data
            })
        },

        /**
         * Listar GrupoTrabalho
         */
         async listarGrupoTrabalho() {
            const urlApi = process.env.VUE_APP_ROOT_API
            const token = JSON.parse(this.$store.getters.getUser).access_token

            axios.get(`${urlApi}/v1/grupotrabalho/listarAtivos`, {
                headers: {
                    'Authorization': token,
                    'Content-Type': 'application/json',
                }
            })
            .then(response => {
              this.dados.grupoTrabalho = response.data
            })
        },

        /**
         * Listar Assessores
         */
         async listarAssessores() {
            const urlApi = process.env.VUE_APP_ROOT_API
            const token = JSON.parse(this.$store.getters.getUser).access_token

            const params = {
                grupoSentinela: 'PGEPROAJU-AGENDAPRAZO-ASSES'
            }

            axios.get(`${urlApi}/v1/usuario`, {
                params: params,
                headers: {
                    'Authorization': token,
                    'Content-Type': 'application/json',
                }
            })
            .then(response => {
              this.dados.assessores = response.data
            })
        },

        async obterProcurador(codProcurador) {
            const urlApi = process.env.VUE_APP_ROOT_API
            const token = JSON.parse(this.$store.getters.getUser).access_token

            await axios.post(`${urlApi}/v1/procurador/obter`, codProcurador, {
                headers: {
                    'Authorization': token,
                    'Content-Type': 'application/json',
                }
            })
            .then(response => {
                this.procurador = response.data
                this.procurador.dataHoraUltimaSincronizacaoFormatada = formatarMixins.methods.formatarDataHora(this.procurador.dataHoraUltimaSincronizacao)
            }).catch((error) => {
                this.exibirErro(error)
            })
        },
    },
    mounted() {
        this.$store.commit("setMessages", {});

        const procuradorEdicao = this.$store.getters.getProcurador;
        if(procuradorEdicao) {
            this.obterProcurador(procuradorEdicao.codProcurador)
        }

        this.listarUfs()
        this.listarUsuarios();
        this.listarGrupoTrabalho()
        this.listarAssessores()
    }
    
}
</script>

<style scoped>
.multiselect--disabled {
    .multiselect__tags {
        background: #e4e7ea;
    }
}

</style>
